module.exports = __webpack_public_path__ + "static/media/puducherry.ed220292.png";